<template>
  <div class="signForm" :style="{ paddingBottom: sealShow ? '275px' : '56px' }">
    <SignHeader v-if="contractNum"></SignHeader>
    <div class="fileList" id="fileForm">
      <div class="item" v-for="(item, index) in (file && file.imageList) || []" :key="item.contractNum">
        <vue-draggable-resizable class-name="item-struct" v-for="(struct, i) in getStruct(index + 1)" :key="i"
          :x="struct.x * ratio" :y="struct.y * ratio" :w="struct.width * ratio * 0.75" :h="struct.height * ratio * 0.75"
          :parent="true" :draggable="hasPosition ? false : true" :resizable="false"
          @dragging="(x, y) => drag({ x, y }, i, struct)"
          @dragstop="(left, top) => onDragStop({ left, top, i, struct })" :style="{
            transform: `translate(${struct.x * ratio}px, ${struct.y *
              ratio}px)`,
            width: `${struct.width * ratio * 0.75}px`,
            height: `${struct.height * ratio * 0.75}px`,
          }">
          <div class="seal-wrap">
            <div class="appoint" v-if="!struct.signImg">签署位置</div>
            <template v-else>
              <i class="el-icon-delete topLeft" @click="deleteCurrent(index + 1, i, struct)"></i>
              <img :src="base64Url(struct.signImg)" alt="" @touchstart="stopMove" />
              <div v-if="struct.signType && !dateImage" class="time" :style="{
                height: `${31 * ratio}px`,
                bottom: `-${31 * ratio}px`,
              }">
                <img @touchstart="stopMove" class="currenDateBase64" :src="textBecomeImg(currenDate, 14, '#000')"
                  alt="" />
                <i class="el-icon-delete bottomLeft" @click="struct.signType = 0"></i>
              </div>
            </template>
          </div>
        </vue-draggable-resizable>
        <img draggable="false" class="fileImg" :id="'fileImg' + index" :src="item" alt="" />
      </div>
    </div>
    <div class="footer" v-if="file && file.imageList">
      <SealAndName v-if="sealShow" @close="close" @setPosition="setPosition" @onDrop="onDrop"></SealAndName>
      <div class="btn-content">
        <div class="btn btn1" @click="toggle">放置签名</div>
        <div class="btn" v-if="hasNest" @click="signNext">切换下一份</div>
        <div class="btn" v-else @click="submit">确认签署</div>
      </div>
    </div>
    <van-popup v-model="codeShow" get-container="body" round :close-on-click-overlay="false" position="bottom"
      @closed="codeShow = false">
      <div class="codeForm" :style="{ height: showKeyboard ? '520px' : '200px' }">
        <div class="header">
          <div class="close" @click="codeShow = false">取消</div>
          短信验证
        </div>
        <div class="getCode" v-if="!signPwdTimerFlag">
          <div class="msg" @click.stop="getTelCode">获取验证码</div>
        </div>
        <div class="getCode" v-else>
          <div class="tag">{{ tel }}</div>
          <div class="msg" @click="getTelCode">重新发送（{{ num }}）</div>
        </div>
        <van-password-input :mask="false" :value="codeValue" :focused="showKeyboard" @focus="showKeyboard = true" />
        <!-- 数字键盘 -->
        <van-number-keyboard v-model="codeValue" :show="showKeyboard" @input="onInput" @delete="onDelete" />
      </div>
    </van-popup>
  </div>
</template>
<script>
import Api from '@/api'
import moment from 'moment'
import textBecomeImg from '@/utils/textBecomeImg'
import { mapState, mapGetters } from 'vuex'
import SignHeader from './components/header.vue'
import SealAndName from './components/SealAndName.vue'

export default {
  components: {
    SignHeader,
    SealAndName,
  },
  data() {
    return {
      sealShow: false,
      currenDate: moment().format('YYYY-MM-DD'),
      currenDateBase64: textBecomeImg(
        moment().format('YYYY-MM-DD'),
        14,
        '#000'
      ),
      codeShow: false, // 是否显示验证码
      codeValue: '', // 验证码
      showKeyboard: false, // 键盘
      signPwdTimerFlag: false,
      num: 60,
      tel: '',
      serialNumber: '',
      signPwdTimer: null, // 定时器实例
    }
  },
  computed: {
    ...mapState({
      signInfo: state => state.sign,
      hideSeal: state => state.sign.hideSeal,
    }),
    ...mapGetters({
      signList: 'sign/signList',
      file: 'sign/file',
    }),
    contractNum() {
      return this.signInfo.contractNum
    },
    wrapWidth() {
      const imgWrap = document.getElementsByClassName('fileList')[0]
      const width = imgWrap ? imgWrap.getBoundingClientRect().width : 375
      return width
    },
    ratio() {
      return this.wrapWidth / 595
    },
    wrapHeight() {
      return this.ratio * 842 + 10
    },
    hasPosition() {
      return !!this.file.signPosition
    },
    hasNest() {
      const newList = this.signList.filter(
        e => e.contractNum !== this.contractNum
      )
      let btn = true
      if (newList.every(e => e.positionList && e.positionList.length)) {
        newList.forEach(e => {
          e.positionList.forEach(item => {
            if (!item.signId) {
              btn = false
            }
          })
        })
      } else {
        btn = false
      }
      return !btn
    },
    dateImage() {
      return this.signInfo.dateImage
    },
  },
  async created() {
    const {
      flowId, // 手机号
      callBack, // 合同编号
      wxCallBack,
      dateImage,
    } = this.$route.query
    this.init()
    this.$store.commit('sign/setfileInfo', {
      flowId,
      callBack,
      wxCallBack:
        wxCallBack && JSON.parse(wxCallBack) ? JSON.parse(wxCallBack) : '',
      dateImage,
    })
    await this.getContractSignInfo()
    this.getsignListFlowId()
  },
  beforeDestroy() {
    // 清理定时器，防止内存泄漏
    if (this.signPwdTimer) {
      clearInterval(this.signPwdTimer)
    }
  },
  methods: {
    init() {
      this.$store.commit('sign/initData')
      this.$store.commit('authentication/initInfo')
    },
    deleteCurrent(page, pageI, struct) {
      if (this.hasPosition) {
        const { height } = struct
        struct.signId = ''
        struct.signImg = ''
        struct.y = struct.y - 140 * 0.75 + height * 0.75
        struct.width = 140
        struct.height = 140
      } else {
        let index = -1
        this.file.positionList.forEach((e, i) => {
          if (e.page === page) {
            index += 1
          }
          if (index === pageI) {
            console.log(i)
            this.$store.commit('sign/deletePositionList', {
              i,
            })
          }
        })
      }
    },
    stopMove(e) {
      e.preventDefault()
    },
    textBecomeImg,
    base64Url(url) {
      return `data:image/png;base64,${url}`
    },
    getStruct(page) {
      return this.file.positionList.filter(e => e.page === page)
    },
    drag(position, index, item) {
      document.querySelector('body').style.overflow = 'hidden'
      this.onDragging(position, index, item)
    },
    onDragging(position, index, item) {
      item.x = position.x / this.ratio
      item.y = position.y / this.ratio
    },
    onDragStop({ left, top, index, item }) {
      document.querySelector('body').style.overflow = 'visible'
    },
    setPosition(sealData) {
      if (this.hasPosition) {
        this.onDrop(0, 0, sealData)
      } else {
        const height =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0
        const left = (this.wrapWidth - 93 * this.ratio) / 2
        this.onDrop(left, height + left, sealData)
      }
    },
    async onDrop(getX, getY, sealData) {
      if (this.file.isFinish === 0) {
        this.$toast('该文件已签署完成')
        return
      }
      console.log(`getX：${getX}getY：${getY}`)
      const { width, height } = sealData
      // 边界校验
      if (getX < 0) {
        getX = 0
      }
      if (getX + width * this.ratio * 0.75 > this.wrapWidth) {
        getX = this.wrapWidth - width * this.ratio * 0.75
      }
      if (getY < 0) {
        getY = 0
      }
      const n = Math.ceil(getY / this.wrapHeight)
      if (getY + height * this.ratio * 0.75 > (this.wrapHeight - 10) * n) {
        getY = (this.wrapHeight - 10) * n - height * this.ratio * 0.75
      }
      getX /= this.ratio
      this.isEnd = false
      if (this.hasPosition) {
        const index = this.file.positionList.findIndex(e => !e.signImg)
        if (index === -1) {
          return
        }
        const minH =
          document.documentElement.scrollTop || document.body.scrollTop
        const maxH =
          minH +
          window.innerHeight -
          document.getElementsByClassName('signHeader')[0].clientHeight -
          document.getElementsByClassName('footer')[0].clientHeight -
          10
        const scrollY =
          this.file.positionList[index].y * this.ratio +
          (this.file.positionList[index].page - 1) * this.wrapHeight
        console.log(`minH:${minH},maxH:${maxH},scrollY:${scrollY}`)
        if (scrollY <= minH || scrollY >= maxH) {
          document.documentElement.scrollTop = scrollY
          document.body.scrollTop = scrollY
        }
        this.$store.commit('sign/fillPositionList', { i: index, sealData })
      } else {
        const { page, y } = this.getCurrentPage(getY)
        this.$store.commit('sign/pushPositionList', {
          contractNum: this.contractNum,
          signId: sealData.signId,
          signImg: sealData.signImg,
          width: sealData.width,
          height: sealData.height,
          x: getX,
          y: y / this.ratio,
          page,
          signType: 1, // 0没有日期 1有日期
        })
      }
    },
    getCurrentPage(y) {
      const disY = y
      if (disY < this.wrapHeight) {
        return {
          page: 1,
          y,
        }
      }
      return {
        page: Math.floor(disY / this.wrapHeight) + 1,
        y: disY % this.wrapHeight,
      }
    },
    close() {
      this.sealShow = false
    },
    toggle() {
      this.sealShow = !this.sealShow
    },
    signNext() {
      if (
        this.file.positionList &&
        this.file.positionList.every(e => e.signId)
      ) {
        const newList = this.signList
          .filter(e => e.contractNum !== this.contractNum)
          .reverse()
        let contractNum = ''
        newList.forEach(e => {
          if (
            !e.positionList.length ||
            e.positionList.some(item => !item.signId)
          ) {
            contractNum = e.contractNum
          }
        })
        this.$store.commit('sign/changeFile', { contractNum })
      } else {
        this.$toast('当前文件您还没有签署')
      }
    },
    async submit() {
      const params = await this.$store.dispatch('sign/getTransformParams')
      console.log(params)
      if (params) {
        if (this.signInfo.type === '1') {
          this.showKeyboard = true
          this.codeShow = true
          this.getTelCode()
          return
        }
        if (
          this.$store.state.authentication.userName &&
          this.$store.state.authentication.idCardNo
        ) {
          this.$router.push('/authentication/face/faceFirst')
        } else {
          this.$router.push('/authentication/face/twoElements')
        }
      }
    },
    async getContractSignInfo() {
      try {
        this.toast = this.$toast.loading({
          message: '获取中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 60000,
        })
        const param = {
          flowId: this.signInfo.flowId,
        }
        const { data } = await Api.getContractSignInfo(param, {
          commitType: 'form',
        })

        this.toast.clear()
        const list = data.list.map(e => {
          const signPosition = e.signPosition
            ? JSON.parse(e.signPosition)
            : null
          let positionList = []
          if (signPosition) {
            signPosition.forEach(item => {
              item.y = 842 - item.y - 140 * 0.75
            })
            positionList = signPosition.map(item => {
              const obj = {
                positionName: item.positionName,
                contractNum: e.contractNum,
                signId: '',
                signImg: '',
                width: 140,
                height: 140,
                x: item.x,
                y: item.y,
                page: item.page,
                signType: 1, // 0没有日期 1有日期
              }
              return obj
            })
          }
          const obj = {
            contractName: e.contractName,
            contractNum: e.contractNum,
            imageList: e.imageList,
            isFinish: e.isFinish,
            signPosition,
            positionList,
          }
          return obj
        })
        if (data.idcardNo && data.name) {
          this.$store.commit('authentication/setInfo', {
            idCardNo: data.idcardNo,
            userName: data.name,
          })
        }

        this.$store.commit('sign/setType', { type: data.type })
        this.$store.commit('sign/setMobile', { mobile: data.mobile })
        this.$store.commit('sign/setHideSeal', { hideSeal: data.hideSeal === 'true' })
        this.$store.commit('sign/setfileList', { list })
      } catch (error) {
        this.toast.clear()
        this.$store.commit('sign/initData')
        console.log(error)
      }
    },
    async getsignListFlowId() {
      try {
        const param = {
          flowId: this.signInfo.flowId,
        }
        const { data } = await Api.getsignListFlowId(param, {
          commitType: 'form',
        })
        let { list } = data

        // 在过滤前检查原始签名数量，如果超过5条则不允许添加新签名
        const canAddSign = list.length < 5

        if (!this.hideSeal) {
          list = list.filter(item => item.signType === 1)
        }

        this.$store.commit('sign/setSignList', { list, canAddSign })
      } catch (error) {
        this.$store.commit('sign/setSignList', { list: [], canAddSign: true })
        console.log(error)
      }
    },
    onInput(key) {
      this.codeValue = (this.codeValue + key).slice(0, 6)
      if (this.codeValue.length === 6) {
        // this.showKeyboard = false
        this.addContract()
      }
    },
    onDelete() {
      this.codeValue = this.codeValue.slice(0, this.codeValue.length - 1)
    },
    async getTelCode() {
      try {
        if (this.num !== 60) return
        const that = this
        that.signPwdTimerFlag = true
        that.signPwdTimer = setInterval(() => {
          that.num -= 1
          if (that.num <= 0) {
            clearInterval(that.signPwdTimer)
            that.signPwdTimerFlag = false
            that.num = 60
          }
        }, 1000)
        // 获取验证码
        await Api.sendMobileSms(
          {
            mobilePhone: that.signInfo.mobile,
            flowId: that.signInfo.flowId,
          },
          {
            commitType: 'form',
          }
        ).then(res => {
          console.log('res', res)
          that.serialNumber = res.data.serialNumber
          that.tel = res.data.smsMessage
        })
      } catch (error) {
        console.log(error)
      }
    },
    async addContract() {
      try {
        const params = await this.$store.dispatch('sign/getTransformParams')
        if (params) {
          params.smsCode = this.codeValue
          params.serialNumber = this.serialNumber
          params.mobilePhone = this.signInfo.mobile
          const { data } = await Api.h5BatchSmsContractSign(params, {
            commitType: 'form',
          })
          this.$router.push('/authentication/face/result')
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
<style lang="less" scoped>
.signForm {
  background: #f4f5f6;
  padding-top: 68px;

  .fileList {
    user-select: none;
    flex: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;

    .item {
      width: 100%;
      margin-bottom: 10px;
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    .item-struct {
      position: absolute;
      z-index: 2 !important;
      background: transparent;
      border: 1px dashed #ffc000;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #5f6368;
      line-height: 56px;
      display: flex;
      align-items: center;
      background: rgba(255, 249, 218, 0.6);

      .seal-wrap {
        display: flex;
        width: 100%;
        height: 100%;

        .appoint {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          line-height: 16px;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }

      .time {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: -20px;
        left: -1px;
        right: -1px;
        height: 20px;
        text-align: center;
        font-size: 10px;
        background: rgba(255, 249, 218, 0.6);
        border: 1px dashed #ffc000;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .el-icon-delete {
        padding: 3px;
        background: url('../../assets/imgs/icon_delete.png') no-repeat center;
        width: 12px;
        height: 12px;
        background-size: 12px 12px;
        position: absolute;
        z-index: 100;
        cursor: pointer;

        &.topLeft {
          left: -9px;
          top: -9px;
        }

        &.bottomLeft {
          left: -9px;
          bottom: -9px;
        }
      }
    }
  }

  .footer {
    position: fixed;
    -webkit-transform: translateZ(0);
    z-index: 103;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px -6px 10px 0px rgba(230, 234, 237, 0.3);

    .btn-content {
      height: 56px;
      padding: 0 16px;
      display: flex;
      align-items: center;
    }

    .btn {
      flex: 1;
      height: 44px;
      border-radius: 4px;
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      line-height: 44px;
      margin: 0 auto;
      // margin-bottom: 10px;
      color: #fff;
      background: #1676ff;
    }

    .btn1 {
      border: 1px solid #1676ff;
      color: #1676ff;
      background: #fff;
      margin-right: 12px;
    }
  }
}

.van-popup {
  .codeForm {
    .header {
      position: relative;
      height: 59px;
      border: 1px solid #f5f5f5;
      background: #f4f5f6;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #111a34;
      line-height: 18px;

      .close {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #677283;
        line-height: 18px;
        position: absolute;
        top: 20px;
        left: 16px;
      }
    }

    /deep/ .van-password-input {
      margin-top: 20px;
    }

    .getCode {
      margin-top: 20px;

      .tag {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #677283;
        text-align: center;
        line-height: 20px;
      }

      .msg {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #1676ff;
        line-height: 20px;
      }
    }
  }
}
</style>
